import { ca } from '@cian/analytics';

export const trackNotEnoughMoneyPopupOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LK_Packages',
    action: 'open',
    label: 'popup_not_anought_money',
  });
};

export const trackGoToPay = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LK_Packages',
    action: 'go2pay',
    label: 'popup_not_anought_money',
  });
};
